module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Doug Paul Case\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Doug Paul Case is author of the book of poems "), _c('I', [_vm._v("Americanitis")]), _vm._v(" and four chapbooks, including "), _c('I', [_vm._v("Contemporary Aesthetics")]), _vm._v(". He is Academic Specialist of English and Assistant Director of Creative Writing at Indiana University and lives in Bloomington.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dNicke/tc-custom/9780253066817.jpg?1732052122787",
      "alt": "This image is the cover for the book Flame Called Indiana"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Flame Called Indiana\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("As Kurt Vonnegut, Indiana's most famous writer, once remarked, \"Wherever you go, there is always a Hoosier doing something important there.\"")])]), _c('p', [_c('i', [_vm._v("A Flame Called Indiana")]), _vm._v(" features 65 writers of fiction, nonfiction, and poetry who have all had the pleasure of being Hoosiers at one time or another. Curated by the Indiana University Bloomington creative writing department, this diverse anthology features everything from the immigrant experience to the Indianapolis 500 to science fiction. Altogether, the work stands testament to the vibrancy and creativity of this Midwest state.")]), _c('p', [_vm._v("An excellent gift for your favorite reader and an important resource for creative writers, "), _c('i', [_vm._v("A Flame Called Indiana")]), _vm._v(" serves as both a chronicle of where Indiana's writing is today and a beacon to those who'll take it where it's going next.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0